module.exports = __webpack_public_path__ + "img/showcase-hero-thumb.3f619925.png";